import { combineReducers } from '@reduxjs/toolkit';
import errorsSlice from '@state/features/errors.slice';
import loadingSlice from '@state/features/loading.slice';
import searchSlice from '@state/features/search.slice';
export const searchReducer = combineReducers({
    search: searchSlice.reducer,
    errors: errorsSlice.reducer,
    loading: loadingSlice.reducer,
});
